// @ts-check
/**
 * Typed client for the task actions API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['SubmitAction']} SubmitAction */
/** @typedef {Schemas['SubmitActionResponse']} SubmitActionResponse */
/** @typedef {Schemas['TaskFilterValuesRequest']} TaskFilterValuesRequest */
/** @typedef {Schemas['TaskFilterValuesResponse']} TaskFilterValuesResponse */
/** @typedef {Schemas['BusinessDaysResponse']} BusinessDaysResponse */

/**
 * POST /api/tasks/submit_action/ — submit a task action.
 * @param {SubmitAction} body
 * @returns {Promise<SubmitActionResponse>}
 */
export async function submitAction(body) {
  const { data } = await axios.post('/api/tasks/submit_action/', body)
  return data
}

/**
 * POST /api/tasks/filters/ — distinct values for the task grid's filter dropdowns,
 * over the tasks the user can see. Pass `fields` to compute only some dropdowns.
 * @param {TaskFilterValuesRequest} [body]
 * @returns {Promise<TaskFilterValuesResponse>} values keyed by dropdown; only the requested keys
 */
export async function getTaskFilterValues(body = {}) {
  const { data } = await axios.post('/api/tasks/filters/', body)
  return data
}

/**
 * GET /api/tasks/business-days/ — the current tenant's observed holidays
 * (ISO dates), used to skip non-business days when picking due dates.
 * @returns {Promise<BusinessDaysResponse>}
 */
export async function getBusinessDays() {
  const { data } = await axios.get('/api/tasks/business-days/')
  return data
}
